import { EntityModificationTrace, WorkCom } from '@wizeoo/akm-message-lib';
import { ViewData } from '../../model/view.data';

/**
 * objet porteur du pack de workcoms chargés
 */
export class WorkcomDataload {
  public static PENDING: string = 'PENDING';
  public static LOADING: string = 'LOADING';
  public static COMPLETE: string = 'COMPLETE';

  public domain: string; // pour contrôle de cohérence sur chargement
  public bu: string; // pour contrôle de cohérence sur chargement
  public vision: string; // pour contrôle de cohérence sur chargement
  public uniqueKey: string; // domain|bu|vision

  public state: string = WorkcomDataload.PENDING; // l'état de chargement de ce pool

  public revisionNumber: number = -1; // dernier numRev local
  public nbWorkcoms: number = 0; // nombre de fds
  public nbDeleteds: number = 0; // nombre de suppressions FD / FDV
  
  public localWcs: Map<string, WorkCom> = new Map(); // les WorkComs stockées en indexDB

  public remoteRevisionNumber: number = -1; // le numRev remote, retourné lors du count

  public workcoms: WorkCom[] = []; // les WorkComs à charger

  public deletedWorkComs: EntityModificationTrace[]; // EMs de suppression sur fds
  public callbacks: Function[] = []; //  fonctions de retour, va renvoyer les localFds (freedatas: FreeData[]) => void; // 

  public freedataCode: string = null; // pour appel sur un seul FD avant commit, pour contrôle d'intégrité

  constructor(domain: string, bu: string, vision: string) {
    this.domain = domain;
    this.bu = bu;
    this.vision = vision;
    this.uniqueKey = [domain,bu, vision].join(ViewData.KEY_SEPARATOR);
   }

   public toPersist: Map<string, WorkCom> = null;
   public toDie: Map<number, EntityModificationTrace> = null;

}
